export const COL_ID_CHECKBOX = "selected";
